import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FallbackProps } from 'react-error-boundary';

export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/error', { replace: true });
  }, [navigate]);

  return null;
}
